import React, { useRef } from "react";
import "../styles/EnrollSection/EnrollSection.css";
import CountrySelect from "../Components/enroll/CountrySelect";

const EnrollmentForm = () => {
  const formRef = useRef(null);

  // ✅ Default India country code
  const countryCodeRef = useRef("+91");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    // ✅ Always send country code
    formData.append("country_code", countryCodeRef.current);
    formData.append("form_type", "Student Admission Inquiry");

    try {
      const response = await fetch(
        "https://formsubmit.co/ajax/admission@madhiacademy.com",
        {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        }
      );

      if (response.ok) {
        alert("Admission inquiry submitted successfully!");
        formRef.current.reset();

        // Reset default country code again
        countryCodeRef.current = "+91";
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      alert("Network error. Please try later.");
    }
  };

  return (
    <div className="enrollment-page-wrapper">

      {/* Header */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-8">
            <h2 className="fw-bold mb-3 text-purple-header">
              Student Admission Inquiry
            </h2>
            <p className="text-secondary small mb-0">
              Begin the admission process by sharing basic details.
            </p>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <section className="enrollment-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-8 col-sm-12">

              <form ref={formRef} onSubmit={handleSubmit}>

                {/* Student Name */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Student Full Name <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="student_name"
                    className="form-control custom-input"
                    required
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label custom-label">
                     Parent Name <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="Parent_name"
                    className="form-control custom-input"
                    required
                  />
                </div>

                {/* Parent Email */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Parent / Guardian Email <span className="required-star">*</span>
                  </label>
                  <input
                    type="email"
                    name="parent_email"
                    className="form-control custom-input"
                    reStudentquired
                  />
                </div>

                {/* Mobile */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Parent / Guardian Mobile <span className="required-star">*</span>
                  </label>

                  <div className="input-group">
                    <CountrySelect
                      defaultCode="+91"
                      onChange={(code) => {
                        countryCodeRef.current = code || "+91";
                      }}
                    />

                    <input
                      type="tel"
                      name="mobile"
                      className="form-control custom-input border-start-0 ps-3"
                      placeholder="Enter Mobile Number"
                      required
                    />
                  </div>
                </div>

                {/* Board */}
                <div className="mb-4">
                  <label className="form-label custom-label mb-2">
                    Board <span className="required-star">*</span>
                  </label>

                  {["CBSE", "State Board"].map((board, i) => (
                    <div className="form-check custom-radio mb-2" key={i}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="board"
                        value={board}
                        required
                      />
                      <label className="form-check-label custom-label">
                        {board}
                      </label>
                    </div>
                  ))}
                </div>

                {/* Grade */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    Grade / Standard <span className="required-star">*</span>
                  </label>
                  <select
                    name="grade"
                    className="form-select custom-input"
                    required
                  >
                    <option value="">Select Grade / Standard</option>
                    {[...Array(12)].map((_, i) => (
                      <option key={i} value={`Class ${i + 1}`}>
                        Class {i + 1}
                      </option>
                    ))}
                  </select>
                </div>

                {/* City */}
                <div className="mb-4">
                  <label className="form-label custom-label">
                    City <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    className="form-control custom-input"
                    required
                  />
                </div>

                {/* Consent */}
                <div className="mb-4 form-check">
                  <input
                    type="checkbox"
                    name="consent"
                    value="Agreed"
                    className="form-check-input"
                    required
                  />
                  <label className="form-check-label custom-label small">
                    I am the parent / guardian and consent to contact.
                  </label>
                </div>

                {/* Hidden FormSubmit Settings */}
                <input
                  type="hidden"
                  name="_subject"
                  value="Student Admission Inquiry"
                />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="table" />

                {/* Submit */}
                <div className="mb-5">
                  <button type="submit" className="btn custom-btn-outline">
                    Start Admission
                  </button>
                </div>

              </form>

              {/* Privacy */}
<div className="privacy-line">
  Privacy: Your data is used only for enrollment communication.
  <span className="separator">&nbsp;|&nbsp;</span> 
  Support:{" "}
  <a href="mailto:support@madhiacademy.com" className="privacy-link">
    support@madhiacademy.com
  </a>
  <span className="separator">&nbsp;|&nbsp;</span> 
  Contact with Us: 7708941960
</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EnrollmentForm;
